var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-sm mt-2"},[_c('span',{staticClass:"flex items-center"},[_c('affiliate-info-icon',{staticClass:"mr-2"}),_vm._v(" "),_vm._m(0)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col font-semibold"},[_c('p',[_vm._v("Max # of ongoing campaigns reached.")]),_vm._v(" "),_c('p',[_vm._v("Complete at least 1 of them before applying to new ones.")])])
}]

export { render, staticRenderFns }